import { DRS } from '@src/types/drs/DRS'

// State of the crew's depot region, which is what the API uses for the DRS PDF and UKG
export function getDRSStateId(drs: DRS | null): string | null {
  if (!drs) {
    return null
  }
  const { plan, actual, edit } = drs.jobDetails
  const crew = [plan, actual, edit]
    .map((pae) => pae && pae.crew)
    .find((crew) => crew && crew.state && crew.state.id)
  return crew && crew.state ? crew.state.id : null
}
